import { Controller } from '@hotwired/stimulus';

// LINE 連携オンボーディングのテスト送信 (#3118)。
// 文言は controller 内で翻訳できないため data value でサーバから受け取る。
export default class extends Controller {
  static targets = ['button', 'result'];
  static values = { sending: String, sendAgain: String, retry: String, error: String };

  async send() {
    this.buttonTarget.disabled = true;
    this.setButtonLabel('fa-spinner fa-spin', this.sendingValue);

    try {
      const res = await fetch('/user/line_onboarding/test_message', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        },
      });
      const data = await res.json();
      this.showResult(
        data.success ? 'alert-success' : 'alert-warning',
        data.success ? 'fa-check-circle' : 'fa-exclamation-triangle',
        data.message,
      );
      this.setButtonLabel('fa-paper-plane', this.sendAgainValue);
    } catch (err) {
      this.showResult('alert-danger', 'fa-times-circle', this.errorValue);
      this.setButtonLabel('fa-paper-plane', this.retryValue);
    }
    this.buttonTarget.disabled = false;
  }

  // メッセージ本文はサーバ由来 (data.message) なので innerHTML では入れない。
  showResult(variant, icon, message) {
    this.resultTarget.style.display = 'block';
    this.resultTarget.className = `alert ${variant} mt-3`;
    this.resultTarget.textContent = '';
    this.resultTarget.append(this.icon(icon), message);
  }

  setButtonLabel(icon, label) {
    this.buttonTarget.textContent = '';
    this.buttonTarget.append(this.icon(icon), label);
  }

  icon(name) {
    const el = document.createElement('i');
    el.className = `fas ${name} me-2`;
    return el;
  }
}
